import { prefixerM } from '.'

export const ROUTE_PAISES = prefixerM('paises')
export const ROUTE_PROVINCIAS = prefixerM('provincias')
export const ROUTE_CIUDADES = prefixerM('ciudades')
export const ROUTE_DISTRITO_ADUANERO = prefixerM('distrito-aduanero')
export const ROUTE_FIDEICOMISO = prefixerM('fideicomiso')
export const ROUTE_FORMA_PAGO_COBRO = prefixerM('forma-pago-cobro')
export const ROUTE_SUSTENTO_TRIBUTARIO = prefixerM('sustento-tributario')
export const ROUTE_CONCEPTOS_RETENCION_FUENTE = prefixerM('conceptos-retencion-fuente')
export const ROUTE_RETENCION_IVA = prefixerM('retencion-iva')
export const ROUTE_EXPORTACIONES = prefixerM('exportaciones')
export const ROUTE_COMPROBANTE = prefixerM('comprobante')
export const ROUTE_PUNTO_EMISION = prefixerM('punto-emision')
export const ROUTE_REGIMEN_FISCAL = prefixerM('regimen-fiscal')
export const ROUTE_CODIGO_FORMULARIO_104 = prefixerM('codigo-formulario-104')
export const ROUTE_CODIGO_FORMULARIO_103 = prefixerM('codigo-formulario-103')
export const ROUTE_POLITICA_IVA = prefixerM('politica-iva')
export const ROUTE_TIPO_CONTRIBUYENTE = prefixerM('tipo-contribuyente')
export const ROUTE_GESTION_PARTIDAS_ARANCELARIAS = prefixerM('gestion-partidas-arancelarias')
export const ROUTE_PARAISO_FISCAL = prefixerM('paraiso-fiscal')
